/**
 * Normalize a user-entered URL so it always opens as an EXTERNAL link.
 *
 * Members often type a website like "example.com" (no scheme). Rendered directly
 * in an <a href>, the browser treats it as a relative path and navigates inside
 * the app (a blank page). This prepends https:// when there's no scheme.
 */
export function externalUrl(raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  // Already a usable scheme (http, https, mailto, tel) — leave as-is.
  if (/^(https?:|mailto:|tel:)/i.test(s)) return s;
  // Protocol-relative (//example.com) → force https.
  if (s.startsWith("//")) return `https:${s}`;
  // Bare domain / path → assume https and strip any leading slashes.
  return `https://${s.replace(/^\/+/, "")}`;
}

/** Pretty version of a URL for display (drops scheme + trailing slash). */
export function displayUrl(raw) {
  if (!raw) return "";
  return String(raw).trim().replace(/^https?:\/\//i, "").replace(/\/+$/, "");
}
